import { Component, inject } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ComponentView } from 'src/modules/app-template/models/component-view.model';
import { FrontendFormDefinition } from '../../models/frontend-form-definition.model';
import { AuthRules } from '../../shared/auth-rules.model';
import { RestEndpoint } from '../../models/rest-endpoint.model';
import { ObjectOfSimpleDataTypes } from 'src/modules/utils/shared/object-of-simple-data-types.model';
import { FrontendFieldDefinition } from '../../models/frontend-field-definition.model';
import { FrontendFieldType } from '../../models/frontend-field-type.enum';
import { Utils } from 'src/modules/utils/shared/utils';

@Component({
  selector: 'app-reset-password-link',
  templateUrl: './reset-password-link.component.html',
  styleUrl: './reset-password-link.component.scss'
})
export class ResetPasswordLinkComponent extends ComponentView {

  message = inject(MessageService);

  neededParams: ObjectOfSimpleDataTypes = { token: "string" };
  token: string;

  form: FrontendFormDefinition;
  authRules: AuthRules;

  userName = null;
  running = false;
  done = false;
  errorMessage: string;

  async initParams(): Promise<boolean> {
    try {
      this.userName = await RestEndpoint.main().query({ token: this.token }).run("api/app/auth/getResetPasswordLinkUser").getString();
    }
    catch (error) {
      this.errorMessage = Utils.toString(error.error);
    }
    this.form = new FrontendFormDefinition([
      new FrontendFieldDefinition("password", "Neues Passwort", FrontendFieldType.password, { mandatory: true, passwordFeedback: false }),
      new FrontendFieldDefinition("passwordRepeat", "Neues Passwort wiederholen", FrontendFieldType.password, { mandatory: true, passwordFeedback: false, validator:
        (field, item) => field.getValue() != item.getValue("password") ? this.app.t("general.changePassword.newPasswordRepeat_error1") : null} )
    ]);
    return true;
  }

  async send(): Promise<void> {
    let errors = this.form.validate();
    if (errors != null) {
        this.message.add({ severity: "error", summary: "Ungültige Angaben", life: 10000, detail: Utils.toString(Utils.objectGetValues(errors)[0])});
        return;
    }
    if (await this.app.messageDialog.yesNo("Soll das Passwort zurückgesetzt werden?", "Bestätigung")) {
      if ((await this.app.genericDataHandler(async () => await RestEndpoint.main().post().body({ token: this.token, userName: this.userName, password: this.form.getValue("password") }).run("api/app/auth/resetPasswordViaToken").getString(), "Fehler", "dialog")).ok) {
        this.message.add({ severity: "success", summary: "Ihr Passwort wurde erfolgreich zurückgesetzt"});
        Utils.setTimerOnce(3000, async () => {
          await this.app.navigateTo(["/base", "login"]);
        });
      }
    }
  }
}  